import React, { Component } from 'react';
import PropTypes from 'prop-types';

import RadioButton from '../../../RadioButton/RadioButton';

export class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: undefined,
    };
  }

  static defaultProps = {
    items: [],
  };

  componentDidMount() {
    this.setState({
      value: this.props.value,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      value: e.value,
    });
    this.props.onSelect(e.value);
  };

  render() {
    const { name, items } = this.props;
    const { value } = this.state;

    return (
      <div>
        {items.map((item, i) => {
          return (
            <RadioButton
              id={i}
              key={i}
              name={name}
              label={item.label}
              value={item.value}
              checked={item.value == value}
              onChange={this.handleChange}
            />
          );
        })}
      </div>
    );
  }
}

CustomSelect.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array,
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
};
